var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.itemComponent,{tag:"component",attrs:{"data":_vm.data,"placeholder":_vm.placeholder,"get-data":_vm.getData},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }